import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

import IMG from "../../../resources/tutorial/Change_Password_Step1.png"

const ChangePasswordInstructions: InstructionComponentProps = {
    name: "Wie kann ich mein Passwort ändern oder zurücksetzen?",
    path: "/help/patient/password",
    both: [
        <ImageTextComponent
            text={
                <>
                    Das Passwort zu ändern ist leider nicht möglich. 
                    Sollten Sie Ihr Passwort vergessen haben, kontaktieren Sie bitte das Studienteam. 
                    <br />
                    <br />
                    <b>Mail:</b> door-hilfe(at)kl.cit.tum.de (Antwortzeit: werktags innerhalb von 48 Stunden)
                    <br />
                    <b>Telefon:</b> +49 89 954 5391 78 (Dienstag und Freitag, 14:00–18:00)
                
                    
                </>
            }
            images={[]}
        />
    ]
}

export default ChangePasswordInstructions
